

export const SET_IS_EPOS_NOW = 'SET_IS_EPOS_NOW';

/** epos now reducer to check if the customer is an eposnow customer */
export function isEposNowReducer(state = false, action: { type: string, payload: boolean }) {
    switch (action.type) {
        case SET_IS_EPOS_NOW:
            state = action.payload;
            return state;
        default:
            return state;
    }
}